<template>
  <div>
    <div class="text-center spinner-container" v-if="loading">
      <b-spinner variant="primary"></b-spinner>
    </div>
    <div v-else>
      <PageHeader :title="title" :items="breadCrumbItens">
        <i class="bx bxs-help-circle font-size-20 div-clickable" @click="iniciarTour()"></i>
        <span class="badge badge-pill font-size-12 mx-3" :class="$tools.corBadge(rdvInfo.item.st_lancamento)">
          {{ this.rdvInfo.item.ds_st_lancamento }}
        </span>
      </PageHeader>
      <b-card>
        <div class="row">
          <div class="col-md-4">
            <div class="col-md-12">
              <div class="form-control">
                <div class="row" data-v-step="3">
                  <comprovante ref="comprovante" v-model="arquivo.comprovante" :status="this.rdvInfo.acao"
                    normaOcrArquivo="N" @enviar-ocr-data="atribuirArquivo" :disabled="this.rdvInfo.acao === 'V'" />
                </div>
              </div>
              <label class="font-size-10" v-if="this.rdvInfo.item.sq_upload">
                {{
                  rdvInfo.item.nm_arquivo_alternativo.split("/")[5] +
                  " - " +
                  $tools.converteDataHora(rdvInfo.item.dt_usuinc_upload)
                }}
              </label>
            </div>
          </div>
          <div class="col-md-8">
            <div class="row pb-4">
              <div class="col-md-3">
                <b-form-group label="Região">
                  <b-form-input :value="dadosTransacao.ds_cidade + ' - ' + dadosTransacao.ds_uf" disabled />
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Estabelecimento">
                  <b-form-input :value="dadosTransacao.nm_posto" disabled />
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Data">
                  <b-form-input :value="$tools.converteData(dadosTransacao.dt_operacao)" disabled />
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Valor">
                  <b-form-input :value="$tools.converteReal(dadosTransacao.vl_operacao)" disabled />
                </b-form-group>
              </div>
            </div>
            <div class="row pb-4">
              <div class="col-md-3">
                <b-form-group label="Placa">
                  <b-form-input class="text-uppercase" :value="dadosTransacao.ds_placa" disabled />
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Tipo Combustível">
                  <b-form-input class="text-uppercase" :value="dadosTransacao.ds_produto" disabled />
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Litros Abastecidos">
                  <b-form-input :value="dadosTransacao.qt_litros" disabled />
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Odômetro informado">
                  <b-form-input class="text-uppercase" :value="dadosTransacao.nr_hodometro_informado" disabled />
                </b-form-group>
              </div>
            </div>
            <div class="row pb-4">
              <div class="col-md-3">
                <b-form-group label="KM Percorrido">
                  <b-form-input
                    :value="parseInt(dadosTransacao.nr_hodometro_informado) - parseInt(dadosTransacao.nr_hodometro_anterior)"
                    disabled />
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Tipo de Lançamento" :state="state('usoParticular')">
                  <multiselect v-model="dados.usoParticular" placeholder="Selecione" :show-labels="false"
                    :allow-empty="false" :options="optionParticular" label="label"
                    :disabled="this.rdvInfo.acao === 'V'" />
                </b-form-group>
              </div>
            </div>
            <div class="row pb-4">
              <div class="col-md-12">
                <b-form-group label="Observação" label-for="observacao">
                  <b-form-textarea id="observacao" v-model="dados.observacao" placeholder="Observações" :maxlength="200"
                    :disabled="this.rdvInfo.acao === 'V'"></b-form-textarea>
                  <div class="text-center">
                    <p v-if="dados.observacao" class="badge position-absolute" :class="{
                      'bg-success': dados.observacao.length !== 200,
                      'bg-danger': dados.observacao.length === 200,
                    }">
                      {{ dados.observacao.length }} / 200
                    </p>
                  </div>
                </b-form-group>
              </div>
            </div>
            <div class="col-md-3">
              <b-form-group label="Valor do Litro">
                <b-form-input :value="dadosTransacao.vl_preco_litro" disabled />
              </b-form-group>
            </div>
            <div class="row mt-4" v-if="justificativas.length > 0">
              <b-card-title> Interações </b-card-title>
              <div class="d-flex flex-column-reverse">
                <b-card no-body class="mb-1 shadow-none" v-for="(justificativa, index) in justificativas" :key="index">
                  <b-card-header header-tag="header" role="tab">
                    <i class="mdi mdi-subdirectory-arrow-right" />
                    <span class="m-0 text-dark" v-b-toggle="'info' + index">
                      {{ $tools.converteData(justificativa.dt_usuinc) }}
                      {{ justificativa.dt_usuinc.substr(11) }} -
                    </span>
                    <span class="m-0 text-dark">
                      {{ justificativa.nm_usuinc }} -
                    </span>
                    <span class="badge badge-pill font-size-12 m-1" :class="{
                      'badge-soft-danger': justificativa.st_status === 'R',
                      'badge-soft-primary': justificativa.st_status === 'A',
                      'badge-soft-warning': justificativa.st_status === 'P',
                    }">
                      {{ $tools.statusDespesa(justificativa.st_status) }}
                    </span>
                  </b-card-header>
                  <b-collapse :id="'info' + index" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <span><strong>Comentário: </strong>
                        <!-- o nome é ds_obs, mas é o ds_interacao (REVISAR) -->
                        {{ justificativa.ds_obs }}</span>
                      <!-- Se for a ultima interação e se for != Pendente-->
                      <hr />
                      <div class="col-md-12" v-if="
                        justificativa.st_status === 'R' &&
                        rdvInfo.item.st_lancamento === 'J' &&
                        index === 0
                      ">
                        <b-form-group label="Justificar" label-for="justificar">
                          <b-form-textarea id="justificar" v-model="ds_interacao" placeholder="Justificar"
                            :maxlength="200"></b-form-textarea>
                          <div class="text-center">
                            <p v-if="ds_interacao" class="badge position-absolute" :class="{
                              'bg-success': ds_interacao.length !== 200,
                              'bg-danger': ds_interacao.length === 200,
                            }">
                              {{ ds_interacao.length }} / 200
                            </p>
                          </div>
                        </b-form-group>
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="col-md-12 d-flex align-items-center justify-content-end"
          >
            <!--
            <div v-if="normaOcr === 'S'">
              <span class="text-muted fst-italic me-3">
                O OCR (Reconhecimento Óptico de Caracteres) pode cometer erros.<br>
                Verifique os dados extraídos antes de salvar.
              </span>
            </div>
            -->
            <div class="d-flex">
              <router-link to="/cooperado/rdv">
                <b-button class="btn-lg me-1" data-v-step="4">
                  Voltar
                </b-button>
              </router-link>
              <div v-if="showDiv && rdvInfo.acao != 'V'">
                <b-button variant="primary" @click="salvarDespesa()" class="btn-lg" :disabled="loading">
                  Salvar
                  <b-spinner small v-if="loading"></b-spinner>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    <limitesNormas ref="normasModal" />
    <!-- <v-tour name="tourMaster" :steps="stepsMaster" :options="tourOptions"></v-tour> -->
  </div>
</template>

<script>
import PageHeader from "@/components/page-header";
import { required } from "vuelidate/lib/validators";
import comprovante from "@/components/formulario/comprovante/comprovante";
import Multiselect from "vue-multiselect";
import limitesNormas from "@/components/cooperado/limitesNorma";

export default {
  components: {
    comprovante, //Componente de comprovante, esta componentizado para todas as carteiras.
    limitesNormas, //Modal que abre as normas, esta componentizado para todas as carteiras.
    PageHeader, //Componente de cabeçalho (Breadcrumb)
    Multiselect
  },

  data() {
    return {
      arquivo: { comprovante: null },
      breadCrumbItens: [
        {
          active: true,
          href: "/cooperado/rdv",
          text: "RDV Digital",
        },
        {
          active: true,
          text: "Ticket Log",
        },
      ],
      dados: {
        usoParticular: { label: "", value: "" },
      },
      rdvGerenciamento: "",
      dadosTransacao: {},
      ds_interacao: "",
      justificativaCooperado: "",
      justificativas: [],
      loading: true,
      rdvInfo: {},
      showDiv: false,
      submit: false,
      rdvOrigem: "",
      optionNorma: [],
      optionParticular: [
        { label: "Uso Particular", value: "P" },
        { label: "Uso a Trabalho", value: "U" },
      ],
      title: "Despesa Ticket Log",
    };
  },

  computed: {
    statusRdv() {
      return this.$store.state.rdvCooperado.acao;
    },
  },

  async created() {
    // Serve somente para criar o BreadCrumb, deixando a manipulação das variáveis para o mounted
    window.scrollTo(0, 0);
    if (this.$store.state.rdvCooperado) {
      this.rdvInfo = this.$store.state.rdvCooperado;
      this.breadCrumbItens.splice(1, 0, { text: this.rdvInfo.rdv.cd_rdv });
      this.breadCrumbItens.splice(2, 0, { text: this.rdvInfo.rdv.cd_projeto });

      //Preenche dados da Transação Ticket Log
      if (this.rdvInfo.item) {
        await this.carregarTransacao();
      }

      this.loading = false; //Se tirar para de carregar a imagem
    } else {
      this.$router.push("/cooperado/rdv");
      this.loading = false;
    }
  },

  async mounted() {
    try {
      this.optionNorma = await this.$tools.filtroCooperado.buscarNormas(
        this.rdvInfo.rdv.cd_projeto
      );
      //Verifica se é uma edição ou visualização
      if (this.rdvInfo.acao === "E" || this.rdvInfo.acao === "V") {
        //Busca a despesa do Ticket Log e joga no BreadCrumb
        //Busca as Normas do RDV desse cooperado/projeto
        this.optionNorma = await this.$tools.filtroCooperado.buscarNormas(
          this.rdvInfo.rdv.cd_projeto
        );

        //Busca todas as cidades do banco
        this.optionCidade = await this.$tools.filtroCooperado.buscarCidades();

        //Verifica se é uma edição ou visualização
        if (this.rdvInfo.acao === "E" || this.rdvInfo.acao === "V") {
          //Busca a despesa do visa e joga no BreadCrumb
          this.breadCrumbItens.push({
            text: this.rdvInfo.item.sq_lcto_goodcard, //VOLTA AQUI
          });

          //Verifica se tem o sq_upload, buscar informações da imagem
          if (this.rdvInfo.item.sq_upload) {
            //Busca o comprovante da despesa
            this.arquivo = await this.$tools.filtroCooperado.buscarComprovante(
              this.rdvInfo.item.sq_upload
            );

            // Verifica se conseguiu buscar o comprovante
            if (this.arquivo) {
              try {
                await this.$refs.comprovante.setArquivo(this.arquivo);
              } catch (error) {
                console.log("Erro ao setar arquivo: ", error);
              }
            } else {
              this.arquivo = {
                comprovante: null,
                trocarImg: null,
                tipoComprovante: null,
              };
            }
          } else {
            this.arquivo = {
              comprovante: null,
              trocarImg: null,
              tipoComprovante: null,
            };
          }

          //Busca as jusficativas da despesa
          this.justificativas =
            await this.$tools.filtroTomador.buscarJustificativas(
              "ticketlog",
              this.rdvInfo.item.sq_lcto_goodcard
            );

          //Busca o veiculo do RDV
          await this.RdvVeiculo();

          // Atribui os campos para edição
          await this.atribuirCampos();

          //Mostra todos os campos
          this.showDiv = true;
        } else {
          // Agora podemos definir o loading como falso após a conclusão da busca da região
          this.loading = false;
        }
      }
    } catch (error) {
      console.error("Erro na busca de dados:", error);
      this.loading = false;
    }
  },

  //Organizado pela ordem de chamada
  methods: {
    async atribuirCampos() {
      this.dados.usoParticular = this.optionParticular.find(
        (el) => el.value == this.rdvGerenciamento.st_origem
      );
      //Preenche a observação
      this.dados.observacao = this.rdvInfo.item.ds_obs;
    },


    async selecionarNorma(selectedNorma) {
      //Limpa os campos

      this.viewCombustivel = false;
      this.viewHospedagem = false;
      try {
        await this.tratarTipoNorma(selectedNorma);
      } catch (erro) {
        console.error("Erro em selecionarNorma: ", erro);
      }
    },

    //Carrega dados da Transação Ticket Log
    async carregarTransacao() {
      this.dadosTransacao =
        await this.$tools.filtroCooperado.buscarTransacaoTicketLog(
          parseInt(this.rdvInfo.item.sq_lcto_utilizacao_frota),
          this.rdvInfo.item.cd_rdv
        );
    },



    async atribuirArquivo(ocrData, dataArquivo) {
      this.arquivo = dataArquivo.arquivo;
    },
    async RdvVeiculo() {
      try {
        const response = await this.fetchRdvVeiculoData();
        await this.processRdvVeiculoData(response);
        await this.RdvVeiculoOrigem(this.rdvVeiculo.sq_veiculo);
        await this.VeiculoGerenciamento(this.rdvInfo.item.sq_gerenciamento);
      } catch (error) {
        console.error("Erro em RdvVeiculo: ", error);
      }
    },

    async fetchRdvVeiculoData() {
      const response = await this.$http.get(
        "/api/telemetria/relatorioVeicularRdv/" + this.rdvInfo.rdv.cd_rdv
      );

      if (!response.data || response.data.length === 0) {
        throw new Error("No data returned from API");
      }
      return response;
    },

    async processRdvVeiculoData(response) {
      this.rdvVeiculo = response.data[0];
      const placas = this.rdvVeiculo.ds_placa.split(",");
      this.optionVeiculo = placas.map((placa) => ({ label: placa }));
      this.carro = {
        label:
          this.optionVeiculo.map((option) => option.label).join(", ") +
          " - " +
          this.rdvVeiculo.nm_versao,
      };
    },
    async RdvVeiculoOrigem(rdvOrigem) {
      try {
        const response = await this.$http.get("/api/telemetria/relatorioGastoCombustivel/" + this.rdvInfo.rdv.cd_rdv + "/" + rdvOrigem);
        this.rdvOrigem = response.data[0];
      } catch (error) {
        console.error("Erro na chamada da API:", error);
      }
    },
    async VeiculoGerenciamento(infoGere) {
      await this.$http
        .get(
          "/api/telemetria/relatorioGastoCombustivelKmFinal/" +
          this.rdvInfo.rdv.cd_rdv +
          "/" +
          this.rdvInfo.item.sq_veiculo + "/" + infoGere
        )
        .then((response) => {
          this.rdvGerenciamento = response.data;
        })
        .catch((error) => {
          console.error("Erro na chamada da API:", error);
        });
    },
    //Temos que validar
    async salvarDespesa() {
      this.loading = true;
      this.submit = true;
      if (!this.arquivo.comprovante) {
        this.$tools.alerta('O comprovante é obrigatório', 'error');
        this.loading = false;
        return;
      }

      // Valida o formulário
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (this.$v.arquivo.$invalid) {
          this.$refs.comprovante.validate(true);
        }
        this.loading = false;
        return;
      }

      // Verifica se pode prosseguir quando houver justificativa vinculada
      const podeProsseguir = await this.verificarJustificativa();
      if (!podeProsseguir) {
        this.loading = false;
        return;
      }

      // Monta o Payload
      const payload = await this.createPayload();

      console.log(payload);

      // Verifica se é uma edição ou inclusão
      const status_despesa = this.rdvInfo.item.st_lancamento;

      this.$http
        .post("api/rdvCooperado/ticketLog/incluir", payload)
        .then(async (response) => {
          this.$store.commit("ENVIAR_NOTIFICACAO", {
            notificacao: "Cadastro com sucesso",
            icone: "success",
          });
          
          try {
            await this.$tools.filtroCooperado.incluirMotivoFalta(
              this.rdvInfo.item,
              null,
              null
            );
          } catch (error) {
            console.error(
              "Não foi possível retirar a justificativa inicial",
              error
            );
          }

          if (response.data.length > 0) {
            // Busca o sq_lcto da interação
            const sq_lcto_interacao = response.data[0].SQ_UTILIZACAO_FROTA
              ? response.data[0].SQ_UTILIZACAO_FROTA
              : this.rdvInfo.item.sq_lcto_utilizacao_frota;

            // Inclui informação de interação inicial
            if (this.rdvInfo.acao === "E" && !this.rdvInfo.item.sq_upload) {
              this.ds_interacao = "Inclusão de despesa Ticket Log Portal Unicampo.";
            }

            // Inclui interação
            if (status_despesa != "P" && this.rdvInfo.acao != "V") {
              await this.incluirInteracao(sq_lcto_interacao);
            }
          } else {
            console.log("Não foi possível salvar a interação.");
          }

          this.$router.push("/cooperado/rdv");
        })
        .catch((err) => {
          const errorMessage = err?.response?.data?.message || "Erro ao salvar despesa.";
          if (errorMessage.includes("sq_veiculo")) {
            this.$tools.alerta("Veículo é obrigatorio", "error");
          } else {
            this.$tools.alerta(errorMessage, "error");
          }
          this.$router.push("/cooperado/rdv");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resolverCdCombustivel() {
      const produtoNormalizado = (this.dadosTransacao?.ds_produto || "")
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase()
        .trim();

      if (!produtoNormalizado) return null;

      if (produtoNormalizado.includes("DIESEL") && produtoNormalizado.includes("S10")) {
        return 11; // OLEO DIESEL S10
      }

      if (produtoNormalizado.includes("DIESEL")) {
        return 10; // OLEO DIESEL
      }

      if (produtoNormalizado.includes("GASOLINA") && produtoNormalizado.includes("ADITIV")) {
        return 6; // GASOLINA ADITIVADA
      }

      if (produtoNormalizado.includes("GASOLINA")) {
        return 7; // GASOLINA COMUM
      }

      if (
        produtoNormalizado.includes("ETANOL") ||
        produtoNormalizado.includes("ALCOOL")
      ) {
        return 5; // ETANOL HIDRATADO
      }

      return null;
    },
    //Função que cria o payload para salvar a despesa
    async createPayload() {
      return {
        arquivo: this.arquivo.trocarImg ? this.arquivo.comprovante : null,
        extensaoArquivo: this.arquivo.trocarImg
          ? this.arquivo.tipoComprovante
          : null,
        sq_upload: this.rdvInfo.item.sq_upload
          ? this.rdvInfo.item.sq_upload
          : null,
        sq_regiao: this.rdvInfo.item.sq_regiao,
        ds_norma: this.rdvInfo.item.ds_norma,
        st_origem: this.dados.usoParticular.value ? this.dados.usoParticular.value : "U",
        sq_utilizacao_frota: parseInt(
          this.rdvInfo.item.sq_lcto_utilizacao_frota
        )
          ? this.rdvInfo.item.sq_lcto_utilizacao_frota
          : null,
        sq_carteira: 6,
        ds_obs: this.dados.observacao,
        st_rdv_ocr: "N",
        acao: this.$store.state.rdvCooperado.acao,
        qt_lancamento: this.parseQuantidadeLancamento(this.dadosTransacao.qt_litros),
        cd_combustivel: this.resolverCdCombustivel(),
      };
    },

    async verificarJustificativa() {
      if (this.rdvInfo.item.sq_transacao_motivo_falta) {
        try {
          await this.$tools.alertaConfirm(
            "Esta ação vai remover a justificativa vinculada a esta despesa, tem certeza que deseja continuar?"
          );
          return true;
        } catch (err) {
          return false;
        }
      }
      return true;
    },

    //Temos que validar
    async incluirInteracao(sq_lcto_interacao) {
      this.$http
        .post("api/rdvCooperado/ticketLog/incluirJustificativa", {
          sq_utilizacao_frota: sq_lcto_interacao,
          st_status: "P",
          ds_obs: this.ds_interacao,
        })
        .then(async () => {
          this.justificativas =
            await this.$tools.filtroTomador.buscarJustificativas(
              "TicketLog",
              sq_lcto_interacao
            );
        })
        .catch((err) => {
          console.log(err);
        });
    },

    state(param) {
      if (this.submit) {
        return !this.$v.dados[param].$invalid;
      } else {
        return null;
      }
    },

    parseQuantidadeLancamento(value) {
      if (value === null || value === undefined || value === "") {
        return null;
      }

      if (typeof value === "number") {
        return Number.isFinite(value) ? value : null;
      }

      if (typeof value === "string") {
        let str = value.trim();
        if (!str) return null;

        if (str.includes(".") && str.includes(",")) {
          if (str.lastIndexOf(",") > str.lastIndexOf(".")) {
            str = str.replace(/\./g, "").replace(",", ".");
          } else {
            str = str.replace(/,/g, "");
          }
        } else if (str.includes(",")) {
          str = str.replace(",", ".");
        }

        const quantidade = parseFloat(str);
        return Number.isFinite(quantidade) ? quantidade : null;
      }

      const quantidade = Number(value);
      return Number.isFinite(quantidade) ? quantidade : null;
    },
  },

  validations: {
    arquivo: {
      required,
    },
  },
};
</script>

<style scoped>
.tentativas {
  display: flex;
  flex-direction: column;
  font-size: 20px;
}

.spinner-container {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1000;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
}
</style>